module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","beds":"Additional Beds","touristTax":"Tourist Tax","checkIn":"Check-In Time","checkOut":"heck-Out Time"},"sl":{"name":"Naziv","beds":"Število dodatnih ležišč","touristTax":"Turistična taksa","checkIn":"Čas Check-Ina","checkOut":"Čas Check-Outa"}}')
  delete Component.options._Ctor
}
